import { EcobalyseAnalysisStatus } from "@tfg/types/schemas/enum"

export type FindProductLcasResponse = {
  data: {
    id: number
    name: string
    brandReference: string
    ecobalyseAnalysis: EcobalyseAnalyisForProductLca
  }[]
  total: number
  allProductIds: number[]
  count: number
}

export enum EcobalyseErrorKeys {
  DEFAULT_ERROR = "DEFAULT_ERROR",
  UNACCESSIBLE_ERROR = "UNACCESSIBLE_ERROR",
  MISSING_DATA_ERROR = "MISSING_DATA_ERROR",
  UNSUPPORTED_DATA_ERROR = "UNSUPPORTED_DATA_ERROR",
}

type EcobalyseAnalyisForProductLca =
  | {
      status: EcobalyseAnalysisStatus.ERROR
      error?: {
        errorKey: EcobalyseErrorKeys
        args: string[]
        rawError: string | null
      }
      dateCreated: Date
    }
  | {
      ecs: number
      pef: number
      webUrl?: string
      dateCreated: Date
      percentFilled: number
      status: EcobalyseAnalysisStatus.SUCCESS
    }
  | {
      status: EcobalyseAnalysisStatus.PENDING
      dateCreated?: Date
    }
